import React from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { multiplier } from '../../utilities/multiplier.js';
import { CssAnimation } from './CssAnimation.jsx';

export function AnimatedTextHeader(props) {

  const { 
    heading, 
    subheading, 
    copy, 
    HeadingTag, 
    blockClasses,
    headingClasses, 
    subheadingClasses, 
    copyClasses,
    subheadingExpandedWidth,
    cssAnimation,
    cssAnimationTrigger
  } = props;

  const block = 'c-animated-text-header';
  const headingParts = heading.split(' ');
  const subheadingAnimationDetails = subheadingExpandedWidth ? '2-1' : '1-0';

  return (
    <header className={
      classNames({
        [block]: true,
        [blockClasses]: blockClasses
      })}
    >
      <CssAnimation 
      enter={{ name: `letter-spacing-contract-${subheadingAnimationDetails}`, duration: 1 }} 
      triggerEnter={cssAnimationTrigger} 
      retrigger={subheading} 
      renderView={!!subheading}
      disable={!cssAnimation}
      >
        <div className={`${block}__subheading ${subheadingClasses}`}>
          { subheading }
        </div>
      </CssAnimation>
      <HeadingTag className={`${block}__heading ${headingClasses}`}>
      {
        headingParts?.map((word, index) => (
          <CssAnimation 
          enter={{ name: 'long-slide-up-fade-in', duration: 0.5, delay: `${multiplier(index, 0.25, 0.01)}, hidden` }} 
          triggerEnter={cssAnimationTrigger}
          retrigger={word} 
          disable={!cssAnimation}
          inViewProps={{ threshold: 0.1}}
          key={word} 
          >
            <span className={`${block}__heading-word ${headingClasses}`}>{ word }</span>
          </CssAnimation>
        ))
      }
      </HeadingTag>
      <CssAnimation 
      enter={{ name: 'fade-in', duration: 1.25, delay: `${!subheading ? 0.5 : 1}, hidden` }} 
      triggerEnter={cssAnimationTrigger}
      retrigger={copy} 
      renderView={!!copy}
      disable={!cssAnimation}
      >
        <div className={`${block}__copy ${copyClasses}`}>
          { copy }
        </div>
      </CssAnimation>
    </header>
  )
};

AnimatedTextHeader.propTypes = {
  heading: propTypes.string.isRequired,
  subheading: propTypes.string, 
  copy: propTypes.string, 
  HeadingTag: propTypes.string, 
  blockClasses: propTypes.string,
  headingClasses: propTypes.string, 
  subheadingClasses: propTypes.string, 
  copyClasses: propTypes.string,
  subheadingExpandedWidth: propTypes.bool,
  cssAnimation: propTypes.bool,
  cssAnimationTrigger: propTypes.oneOfType([
    propTypes.string,
    propTypes.bool
  ])
};

AnimatedTextHeader.defaultProps = { 
  HeadingTag: 'h2',
  headingClasses: 'h1',
  subheadingClasses: 'h5',
  copyClasses: 'quote',
  cssAnimation: true,
  cssAnimationTrigger: 'in-view-init'
};